type FlightOrderItemId = string

function getFlightDetailsByOrderItems(order: App.Order, flightDetails: App.ApiStateRecord<{ flight: App.FlightOrderItemDetails }>): Record<FlightOrderItemId, App.FlightOrderItemDetails> | undefined {
  if (!Object.keys(flightDetails).length) return

  const flightItemIds = order?.flightItems.map(item => item.id) || []

  const flightDetailsByItem: Record<FlightOrderItemId, App.FlightOrderItemDetails> = Object.entries(flightDetails)
    .filter(([flightItemId, flightDetail]) => {
      if (flightDetail?.fetching) return false
      return flightItemIds.includes(flightItemId)
    })
    .reduce((acc, [flightItemId, flightDetail]) => {
      return {
        ...acc,
        [flightItemId]: flightDetail?.flight,
      }
    }, {})

  return flightDetailsByItem
}

export default getFlightDetailsByOrderItems
